import { Field, ErrorMessage } from 'formik'
import React from 'react'

import FormFieldErrorMessage from './form-field-error-message'
import Tooltip from '../tooltip/tooltip'

const SelectFormikField: React.FC<any> = ({
  touched = {},
  errors = {},
  label = '',
  newLineForHelpText = true,
  helpText = '',
  data = [],
  name = '',
  className = '',
  required = false,
  toolTipMessage = '',
  toolTipTitle = '',
  placeholder = '– Välj...',
  readOnly = false,
}) => (
  <div className={className}>
    <label
      className={`${readOnly && 'border-bottom'} flex flex-col justify-between py-3 sm:items-start label` }
    >
      {label ? (
        <span className="text-base text-black">
          {label} {required ? <span className="text-warn-600">*</span> : ''}{' '}
          {newLineForHelpText ? <br /> : null}{' '}
          {helpText ? <span className="font-normal text-xs">{helpText}</span> : null}
        </span>
      ) : null}
      <div className="w-full">
        <div className="flex justify-between items-center">
          <Field
            as="select"
            name={name}
            className={`appearance-none bg-white p-2 rounded w-11/12 mt-1 text-gray-900 
            ${
              readOnly && 'appearance-none'
            } ${
              errors[name] && touched[name] ? 'border-2 border-warn-600' : 'border border-lightGray'
            }`}
            disabled={readOnly}
          >
            <option
              className="bg-white border border-lightGray p-2 rounded w-11/12 mt-1 text-gray-900"
              disabled
              value=""
            >
              {placeholder}
            </option>
            {data.map((element) => (
              <option
                className="bg-white border border-lightGray p-2 rounded w-11/12 mt-1 text-gray-900"
                key={element.id}
                value={element.id}
              >
                {element.name}
              </option>
            ))}
          </Field>
          {toolTipMessage ? <Tooltip message={toolTipMessage} title={toolTipTitle || ''} /> : null}
        </div>
      </div>
      <div className="min-h-6">
        <ErrorMessage component={FormFieldErrorMessage} name={name} />
      </div>
    </label>
  </div>
)

export default SelectFormikField
